import { render, staticRenderFns } from "./DynamicAttributeConfigurationSearchable.vue?vue&type=template&id=1089d604&"
import script from "./DynamicAttributeConfigurationSearchable.vue?vue&type=script&lang=ts&"
export * from "./DynamicAttributeConfigurationSearchable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports